import { render, staticRenderFns } from "./AddPlugin.vue?vue&type=template&id=039d2884&"
import script from "./AddPlugin.vue?vue&type=script&lang=js&"
export * from "./AddPlugin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports